import { BlogSection } from '@/types/blog';

export const routinenSection: BlogSection = {
  id: 'routinen',
  title: 'Erfolgreiche Geld-Routinen etablieren',
  content: `
    <h3>5. Erfolgreiche Geld-Routinen etablieren</h3>
    
    <p>
      Kleine, aber konsequente Handlungen haben langfristig den größten Einfluss. Starte mit simplen Routinen wie:
    </p>
    
    <ul class="my-4">
      <li class="flex items-start mb-3">
        <span class="bg-green-500 text-white rounded-full min-w-[20px] h-[20px] flex items-center justify-center mr-2 mt-1">✓</span>
        <span><strong>Monatliches Finanz-Check-in einführen</strong> - Plane einen festen Termin im Kalender für die Überprüfung deiner Finanzen</span>
      </li>
      <li class="flex items-start mb-3">
        <span class="bg-green-500 text-white rounded-full min-w-[20px] h-[20px] flex items-center justify-center mr-2 mt-1">✓</span>
        <span><strong>Automatische Sparpläne aktivieren</strong> - "Pay yourself first" - Zahlungen an dich selbst priorisieren</span>
      </li>
      <li class="flex items-start">
        <span class="bg-green-500 text-white rounded-full min-w-[20px] h-[20px] flex items-center justify-center mr-2 mt-1">✓</span>
        <span><strong>Regelmäßige Weiterbildung zu Geldthemen</strong> - Wöchentlich 30 Minuten in deine finanzielle Bildung investieren</span>
      </li>
    </ul>
    
    <div class="my-8">
      <img 
        src="/images/blog/finanz-routinen.webp" 
        alt="Person plant Finanzen am Schreibtisch mit Notizen - Finanzroutinen etablieren" 
        class="rounded-lg w-full h-auto shadow-md" 
      />
      <p class="text-sm text-center mt-2 text-joerg-600">Strukturierte Finanzroutinen bringen Klarheit und Sicherheit</p>
    </div>
  `
};